import { render, staticRenderFns } from "./TableFileSignature.vue?vue&type=template&id=f8fc2f0e&scoped=true&"
import script from "./TableFileSignature.vue?vue&type=script&lang=ts&"
export * from "./TableFileSignature.vue?vue&type=script&lang=ts&"
import style0 from "./TableFileSignature.vue?vue&type=style&index=0&id=f8fc2f0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fc2f0e",
  null
  
)

export default component.exports